import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const DetailAddonInfoName = styled.div<React.CSSProperties>`
  font-family: ${Fonts['regular']};
  color: ${Colors['light']};
  font-size: ${Screen.widthRatio * 32}px;
  margin-bottom: ${Screen.widthRatio * 25}px;
  margin-top: ${Screen.widthRatio * 12}px;
`;

export default DetailAddonInfoName;
